import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { RootState } from '../reduxProvider'
import { BrandInfo, BrandsInfoState, BrandSummary } from './types'

const initialState: BrandsInfoState = {
  detail: null,
  list: [],
  isLoaded: false,
}

export const brandsSlice = createSlice({
  name: 'brandsInfo',
  initialState,
  reducers: {
    showLoader: (state) => {
      state.isLoaded = false
    },
    hideLoader: (state) => {
      state.isLoaded = true
    },
    setList: (state, action: PayloadAction<BrandSummary[]>) => {
      state.list = action.payload
    },
    setBrand: (state, action: PayloadAction<BrandInfo | null>) => {
      state.detail = action.payload
    },
  },
})

export const { showLoader, hideLoader, setList, setBrand } = brandsSlice.actions

export const selectBrands = (state: RootState) => state.brandsInfo

export default brandsSlice.reducer
